import React from "react";
import { SENTIMENT_SHAPES } from "../../../sentiment/glyph-shapes";

const { viewBox, Shape } = SENTIMENT_SHAPES.LIKE;

// Thumbs up, from the shared rating glyphs so it matches the thumb used elsewhere.
export const LikeIcon = ({
  width = 20,
  height = 20,
  color = "currentColor",
}: {
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    aria-hidden
    style={{ display: "block", flexShrink: 0 }}
  >
    <Shape fill={color} stroke={color} strokeWidth={0} />
  </svg>
);
